import {
  PROJECT_ID,
  PROJECT_USER_ID,
  PROJECT_USER_ROLE,
  USER_IS_OWNER
} from "../constants/storageKeys";

export const removeProjectRelatedLocalStorage = () => {
  localStorage.removeItem(PROJECT_USER_ID);
  localStorage.removeItem(USER_IS_OWNER);
  localStorage.removeItem(PROJECT_USER_ROLE);
  localStorage.removeItem(PROJECT_ID);
};

export const getProjectRelatedLocalStorage = () => {
  return (
    localStorage.getItem(PROJECT_USER_ID) &&
    localStorage.getItem(USER_IS_OWNER) &&
    localStorage.getItem(PROJECT_USER_ROLE) &&
    localStorage.getItem(PROJECT_ID)
  );
};
